import {createSelector} from '@reduxjs/toolkit';

import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {ApplicationStoreType} from 'desktop/store';

import {PaymentMethodSaveType} from '../../../reducers/paymentStep/paymentMethodSave/paymentMethodSave';
import {getCompleteOrderFirstError} from '../../completeOrder/completeOrder';
import {MODULE_KEY_CHECKOUT} from '../../constants';
import {getMessageError, getNameSelectedMethod} from '../paymentStep';

/**
 * Get Google Pay data
 *
 * @param {ApplicationStoreType} store - current store
 * @return {GooglePayType} - amazon data
 */
const getPaymentMethodSave = (store: ApplicationStoreType): PaymentMethodSaveType =>
    store[MODULE_KEY_CHECKOUT].paymentStep.paymentMethodSave;

/**
 * Get is payment method loading
 *
 * @param {ApplicationStoreType} store - current store
 * @return {boolean} - payment method is loading
 */
export const getPaymentMethodSaveLoading = createSelector(
    getPaymentMethodSave,
    paymentMethod => paymentMethod.loading,
);

/**
 * Get error for Google pay from save/saveOrder
 *
 * @param {ApplicationStoreType} store - current store
 * @return {string} - error message
 */
export const getGooglePayMessageError = createSelector(
    getMessageError,
    getCompleteOrderFirstError,
    getNameSelectedMethod,
    (messageError, orderError, selectedMethod) => {
        if (
            selectedMethod === PAYMENTS.METHOD_GOOGLE_PAY ||
            selectedMethod === PAYMENTS.METHOD_PRIMER_GOOGLE_PAY
        ) {
            return messageError || orderError || '';
        }
        return '';
    },
);

/**
 * Get error for PayPalV3 from save/saveOrder
 *
 * @param {ApplicationStoreType} store - current store
 * @return {string} - error message
 */
export const getPayPalV3MessageError = createSelector(
    getMessageError,
    getCompleteOrderFirstError,
    getNameSelectedMethod,
    (messageError, orderError, selectedMethod) => {
        if (selectedMethod === PAYMENTS.METHOD_PAYPAL_V3) {
            return messageError || orderError || '';
        }
        return '';
    },
);

/**
 * Get error for Venmo from save/saveOrder
 *
 * @param {ApplicationStoreType} store - current store
 * @return {string} - error message
 */
export const getVenmoMessageError = createSelector(
    getMessageError,
    getCompleteOrderFirstError,
    getNameSelectedMethod,
    (messageError, orderError, selectedMethod) => {
        if (selectedMethod === PAYMENTS.METHOD_VENMO) {
            return messageError || orderError || '';
        }
        return '';
    },
);

/**
 * Get error for Klarna from save/saveOrder
 *
 * @param {ApplicationStoreType} store - current store
 * @return {string} - error message
 */
export const getKlarnaMessageError = createSelector(
    getMessageError,
    getCompleteOrderFirstError,
    getNameSelectedMethod,
    (messageError, orderError, selectedMethod) => {
        if (selectedMethod === PAYMENTS.METHOD_PRIMER_KLARNA) {
            return messageError || orderError || '';
        }
        return '';
    },
);
